// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import { PersistentObject } from '../../../SagaBase/PersistentObject';
import * as SagaBase from '../../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class ListCrisisUsers_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.ListObjects.ListCrisisUsers';
  $t: string = 'SagaSchema.ListObjects.ListCrisisUsers';

  public static GetMembers(): string[] {
    return ['Name', 'Value', 'SiteId', 'FirstName', 'LastName'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return ListCrisisUsers_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Name: string;
  public Value: any;
  public SiteId: number = 0;
  public FirstName: string = '';
  public LastName: string = '';

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  /*</AUTO_IMPLEMENTATION>*/
}
